import { Fragment, useEffect } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Chats, PrivateChat } from "../../../../Constants/Constants";
import { useAppDispatch } from "../../../../ReduxToolkit/Hooks";
import { fetchChatApiData, fetchChatMemberApiData } from "../../../../ReduxToolkit/Reducers/ChatSlice";
import LeftSideBar from "./LeftSideBar/LeftSideBar";
import UserChat from "./UserChat/UserChat"

const PrivateChatContainer = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchChatMemberApiData());
    dispatch(fetchChatApiData());
  }, [dispatch]);
  return (
    <Fragment>
      <Breadcrumbs mainTitle={PrivateChat} parent={Chats} />
      <Container fluid>
        <Row className="g-0">
          <LeftSideBar />
          <UserChat />
        </Row>
      </Container>
    </Fragment>
  );
};

export default PrivateChatContainer;
